define('viewModels/privileged/qm/InteractionsMain',[
    'viewModels/ViewModel',
    'viewModels/SwitchedView',
    'viewModels/privileged/qm/PlaybackView',
    'viewModels/privileged/qm/InteractionsSearchTabsView'
], function (
    ViewModel,
    SwitchedView,
    PlaybackView,
    InteractionsSearchTabsView
) {
    'use strict';


    var InteractionsMain = ViewModel.extend(function () {
        var self = this;

        /**
         * Child views
         * @type {viewModels.SwitchedView}
         */
        self.subViews = self.subView(SwitchedView, {
            interactionsSearchTabsView: InteractionsSearchTabsView,
            playbackView: PlaybackView
        });
    });

    return InteractionsMain;
});

